/**
 * Public surface of the store.
 *
 * Components import the atomic hooks below rather than calling
 * `useAppStore` with an inline selector. Zustand v5 compares selector
 * results with Object.is, so a selector returning a fresh object re-renders
 * forever. Selecting one primitive at a time makes that impossible, and a
 * component re-renders only when its one field changes.
 */

export { useAppStore, getAppState } from './useAppStore';
export type { AppState, SliceCreator } from './types';

import { useAppStore } from './useAppStore';

/* Theme */
export const useThemePreference = () => useAppStore((state) => state.themePreference);
export const useResolvedTheme = () => useAppStore((state) => state.resolvedTheme);
export const useSetThemePreference = () => useAppStore((state) => state.setThemePreference);

/* Glass */
export const useGlassMode = () => useAppStore((state) => state.glassMode);

/* UI */
export const useIsMenuOpen = () => useAppStore((state) => state.isMenuOpen);
export const useToggleMenu = () => useAppStore((state) => state.toggleMenu);
export const useCloseMenu = () => useAppStore((state) => state.closeMenu);

/* Preferences */
export const usePrefersReducedMotion = () => useAppStore((state) => state.prefersReducedMotion);
